<script>
	import SmartLink from '../../../../helpers/SmartLink.svelte';
	import { getText } from '../../../../share/utils';
</script>

<div class="container marginbox_right">
	<div class="element__left">
		<img loading="lazy" alt="Gewinnspiel-Website des Backmittelherstellers Kathi auf diversen Screens"
			 src="./img/01.Home/05.frontend-entwicklung/kathi_LP_responsive_K.webp">
	</div>

	<div class="element__right">
		<h2>{getText("01.05.01_h2")}</h2>
	</div>

	<div class="element__w_100_40">
		<p class="caption">{getText("01.05.02_caption")}</p>
		<SmartLink extraClass="see_more_button" text="Mehr erfahren" url="portfolio/appetit_digitalisieren#kathi"/>
	</div>
</div>


<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";

	.container {
		width: 100%;

		@include for-tablet-portrait-up {
			margin-bottom: $spacing-mobile-half;
		}
	}

	.element__left {
		float: left;
		width: 65%;
		padding: 0 $media-gap;

		@include for-tablet-portrait-up {
			padding-right: $spacing-mobile;
		}
	}

	.element__right {
		float: right;
		width: 35%;
		padding: $spacing-mobile-one-third $media-gap 0 0;
		word-break: break-word;
		hyphens: auto;
	}

	.element__w_100_40 {
		float: left;
		width: 100%;
		padding: $media-gap $spacing-mobile 0 $spacing-mobile;

		@include for-tablet-portrait-up {
			float: right;
			width: 35%;
			padding: 0;
		}
	}

	img {
		width: 100%;
		margin: 0;
		padding: 0;

		@include for-tablet-landscape-up {
			width: auto;
			max-height: 500px;
			position: relative;
			left: 100%;
			transform: translateX(-100%);
		}
	}

	h2 {
		margin-bottom: $spacing-mobile-one-third;
	}

	p {
		margin-bottom: $media-gap;
	}

	:global(.see_more_button a::before) {
		margin-right: $spacing-mobile*0.3;
		content: '';
		font-family: monospace;
		line-height: 1;
		width: 0.9em;
		height: 0.9em;
		top: .1em;
		position: relative;
		display: inline-flex;
		right: 0;
		aspect-ratio: 1;
		background-color: var(--color-burgeins-6);
		color: var(--custom-background-color, white);
		-webkit-mask: url("../img/icons/IconPlus.svg") no-repeat 50% 50%;
		mask: url("../img/icons/IconPlus.svg") no-repeat 50% 50%;
		-webkit-mask-size: cover;
		mask-size: cover;
		text-align: center;
	}
</style>

